import { AssetProcessingState } from '@packages/clients';

import { StsBackendOperation } from '../../../sts-backend-operation';

/** Parameters for deleting a techline asset. */
export type DeleteAssetParams = {
    /** The ID of the asset to delete. */
    assetId: string;
};

/**
 * Soft-deletes a techline case asset by setting its processing state to ERROR.
 * The asset is not physically removed; it becomes invisible to the user.
 */
export class DeleteAsset extends StsBackendOperation {
    /**
     * Mark an asset as deleted by updating its processing state to ERROR.
     *
     * @param params - the asset to delete
     */
    async exec(params: DeleteAssetParams): Promise<void> {
        const { assetId } = params;
        await this.client.updateAssets({
            assetsBody: {
                assets: [{ assetId, processingState: AssetProcessingState.Error, percentUploaded: 0 }],
            },
        });
    }
}
